<template>
    <el-row v-loading="!initialized">
        <el-col :span="24" v-if="initialized">

            <el-row style="margin-top:20px">
                <el-col :span="24">
                    <btn :click="() => applyDefaultPricing('jan2026', 'agency')" :icon="loadingDefaultPricing.agency.jan2026 ? 'fa fa-pulse fa-spinner' : 'fas fa-dollar-sign'" css-class="btn-primary btn-sm">Apply Agency Pricing (2026)</btn>
                    <btn :click="() => applyDefaultPricing('jan2026', 'direct')" :icon="loadingDefaultPricing.direct.jan2026 ? 'fa fa-pulse fa-spinner' : 'fas fa-dollar-sign'" css-class="btn-primary btn-sm">Apply Direct Pricing (2026)</btn>
                    <span style="margin-left: 20px;"></span>
                    <btn :click="() => applyDefaultPricing('may2022', 'agency')" :icon="loadingDefaultPricing.agency.may2022 ? 'fa fa-pulse fa-spinner' : 'fas fa-dollar-sign'" css-class="btn-success btn-sm">Apply Agency Pricing (2025)</btn>
                    <btn :click="() => applyDefaultPricing('may2022', 'direct')" :icon="loadingDefaultPricing.direct.may2022 ? 'fa fa-pulse fa-spinner' : 'fas fa-dollar-sign'" css-class="btn-success btn-sm">Apply Direct Pricing (2025)</btn>
                </el-col>
            </el-row>

            <el-row style="margin-top:40px">
                <el-col :span="8" class="pr-10">
                    <h3>Direct Leads</h3>
                    <el-form-item v-for="(budget, index) in cdlOptions"
                                  :key="`directBudget${budget.key}`"
                                  :label="budget.label">
                        <el-input type="number"
                                  v-model="formValues.direct[budget.key]"
                                  precision="2"
                                  step="0.01"
                                  @input="updateFormValues">
                            <template slot="prepend">$</template>
                        </el-input>
                    </el-form-item>
                    The direct pricing also governs the price of calls & 3rd party LP conversions.
                </el-col>
                <el-col :span="8" class="pr-10">
                    <h3>JobAdviser</h3>
                    <el-form-item v-for="(budget, index) in cdlOptions"
                                  :key="`directBudget${budget.key}`"
                                  :label="budget.label">
                        <el-input type="number"
                                  v-model="formValues.jobadviser[budget.key]"
                                  precision="2"
                                  step="0.01"
                                  @input="updateFormValues">
                            <template slot="prepend">$</template>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8" class="pl-10">
                    <h3>Multi Carrier Leads</h3>

                    <el-form-item v-for="(budget, index) in cdlOptions"
                                  :key="`multiBudget${budget.key}`"
                                  :label="budget.label">
                        <el-input type="number"
                                  v-model="formValues['multi-carrier'][budget.key]"
                                  precision="2"
                                  step="0.01"
                                  @input="updateFormValues">
                            <template slot="prepend">$</template>
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>



            <h3>Campaign</h3>
            <el-form-item prop="specs.pricing.campaign">
                <el-select v-model="formValues.campaign" style="width:100%" @change="updateFormValues" multiple>
                    <el-option-group label="Active">
                        <el-option v-for="item in campaigns.active"
                                   :key="`item${item.id}`"
                                   :label="item.name"
                                   :value="item.id"/>
                    </el-option-group>
                    <el-option-group label="Inactive">
                        <el-option v-for="item in campaigns.inactive"
                                   :key="`item${item.id}`"
                                   :label="item.name"
                                   :value="item.id"/>
                    </el-option-group>
                </el-select>
            </el-form-item>
        </el-col>
    </el-row>
</template>

<script>
    export default {
        props: {
            jobId: { type: Number, required: true },
            employerId: { type: Number, required: true },
            value: { type: Object, required: true },
            cdlXp: { type: String, required: true },
            isOwnerOperatorsJob: { type: Boolean, required: true },
            isLeasePurchaseJob: { type: Boolean, required: true },
            isTeamJob: { type: Boolean, required: false, default: false },
            isTankerJob: { type: Boolean, required: false, default: false },
            isHazmatJob: { type: Boolean, required: false, default: false },
            isEmpty: { type: Boolean, required: false },
        },
        data() {
            return {
                initialized: false,
                cdlOptions: {},
                campaigns: {},
                formValues: this.value,
                loadingDefaultPricing: {
                    direct: {
                        may2022: false,
                        jan2026: false,
                    },
                    agency: {
                        may2022: false,
                        jan2026: false,
                    }
                },
                products: ['direct', 'multi-carrier', 'driverengage', 'jobadviser']
            };
        },
        mounted() {
            axios.get(url(`/admin/jobs/load-form-pricing-data?jobId=${this.jobId}&employerId=${this.employerId}`))
                 .then(response => {
                     if (response.status !== 200 ||
                         typeof response.data.options === 'undefined' ||
                         typeof response.data.budgets === 'undefined' ||
                         typeof response.data.campaigns === 'undefined') {

                         throw Error('Pricing values could not be loaded.');
                     }

                     this.cdlOptions = _.orderBy(response.data.options, ['key'], ['asc']);
                     this.campaigns = response.data.campaigns;
                     this.formValues = response.data.budgets;

                     this.initialized = true;
                     this.updateFormValues();
                 })
                 .catch(err => { this.$emit('error', err.message); });
        },
        watch: {
            formValues: {
                handler(newValue) {
                    let containsNonZeroValue = false;
                    this.products.forEach(product => {
                        let index;
                        for(index in newValue[product]) {
                            if (!newValue[product].hasOwnProperty(index)) continue;
                            if (newValue[product][index] > 0) {
                                containsNonZeroValue = true;
                            }
                        }
                    });

                    this.$emit('update:isEmpty', !containsNonZeroValue);
                },
                deep: true,
            },
        },
        methods: {
            updateFormValues() { this.$emit('input', this.formValues); },
            applyDefaultPricing(pricelistName, pricingType) {
                this.$set(this.loadingDefaultPricing[pricingType], pricelistName, true);
                const self = this;
                axios.get(
                    url(`/ajax/get-default-pricing?pricelist=${pricelistName}&isOwner=${self.isOwnerOperatorsJob}&isLeasePurchase=${self.isLeasePurchaseJob}&cdlXp=${self.cdlXp}&pricingType=${pricingType}&employerId=${self.employerId}&isTeam=${self.isTeamJob}&isTanker=${self.isTankerJob}&isHazmat=${self.isHazmatJob}`))
                     .then(response => {
                         self.products.forEach(function (product) {
                             if (product === 'driverengage') return;
                             Object.keys(response.data[product])
                                   .forEach((xpLevel) => {
                                       self.$set(self.formValues[product], xpLevel, response.data[product][xpLevel]);
                                   });
                         });

                         self.updateFormValues();
                     })
                     .catch(err => {
                         self.$alert('Default budget cannot be loaded due to: ' + err.message, 'Error :(');
                     })
                     .finally(() => { self.$set(self.loadingDefaultPricing[pricingType], pricelistName, false); });
            },
        },
    };
</script>

<style scoped>
    h3 {
        margin: 20px 0;
    }

    .pl-10 {
        padding-left: 10px;
    }

    .pr-10 {
        padding-right: 10px;
    }
</style>
